import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { OwlOptions, CarouselComponent, SlidesOutputData } from "ngx-owl-carousel-o";

@Component({
  selector: "app-taxcard-quality-info",
  templateUrl: "./taxcard-quality-info.component.html",
  styleUrls: ["./taxcard-quality-info.component.scss"],
  standalone: false
})
export class TaxcardQualityInfoComponent implements OnInit {
  SLIDES_COUNT = 4;
  @Input() callback: any;
  @ViewChild("owlCar", { static: false }) owlCar!: CarouselComponent;
  public currentSlide = 0;
  public customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    margin: 20,
    animateOut: true,
    responsive: {
      0: {
        items: 4
      }
    }
  };

  constructor(private dialogRef: MatDialogRef<TaxcardQualityInfoComponent>) {}

  ngOnInit() {}

  getPassedData(data: SlidesOutputData) {
    this.currentSlide = data.startPosition;
  }

  onAccept() {
    if (typeof this.callback === "function") {
      this.callback();
    }
    this.dialogRef.close();
  }
}
